const config = {
  baseApi: process.env.REACT_APP_BASE_URL || 'http://192.168.1.4:3030/v1/',
  baseImage: process.env.REACT_APP_IMAGE_URL || 'http://192.168.1.4:3030/',
};

export default config;
